import * as React from "react";

const NewSearchIcon = (props: { color: string }): JSX.Element => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.516 5.75C7.88379 5.75 5.75 7.88379 5.75 10.516C5.75 13.1481 7.88379 15.2819 10.516 15.2819C13.1481 15.2819 15.2819 13.1481 15.2819 10.516C15.2819 7.88379 13.1481 5.75 10.516 5.75ZM4.25 10.516C4.25 7.05536 7.05536 4.25 10.516 4.25C13.9766 4.25 16.7819 7.05536 16.7819 10.516C16.7819 11.976 16.2826 13.3194 15.4453 14.3847L19.5303 18.4697C19.8232 18.7626 19.8232 19.2374 19.5303 19.5303C19.2374 19.8232 18.7626 19.8232 18.4697 19.5303L14.3847 15.4453C13.3194 16.2826 11.976 16.7819 10.516 16.7819C7.05536 16.7819 4.25 13.9766 4.25 10.516Z"
                fill={props.color}
            />
        </svg>
    );
};

export default NewSearchIcon;
